/**
 * Bee Hive partner pages — mobile nav dropdown (max-width 749px only).
 */
(function (global) {
  'use strict';

  var MQ = '(max-width: 749px)';
  var OPEN_CLASS = 'bh-partner-nav-dropdown-open';

  function isMobileNav() {
    try {
      return global.matchMedia(MQ).matches;
    } catch (e) {
      return global.innerWidth <= 749;
    }
  }

  function closePanel(panel, btn, topbar) {
    if (!panel || !btn) return;
    panel.removeAttribute('data-bh-nav-open');
    btn.setAttribute('aria-expanded', 'false');
    panel.classList.remove('bh-mia-topnav-rail--dropdown-fixed');
    panel.style.top = '';
    panel.style.left = '';
    panel.style.right = '';
    panel.style.width = '';
    panel.style.maxWidth = '';
    if (topbar) topbar.classList.remove(OPEN_CLASS);
    document.documentElement.classList.remove(OPEN_CLASS);
  }

  function positionPanel(panel, topbar) {
    var rect = topbar.getBoundingClientRect();
    var inset = Math.max(12, Math.min(16, global.innerWidth * 0.04));
    panel.classList.add('bh-mia-topnav-rail--dropdown-fixed');
    panel.style.top = Math.round(rect.bottom + 6) + 'px';
    panel.style.left = inset + 'px';
    panel.style.right = inset + 'px';
    panel.style.width = 'auto';
    panel.style.maxWidth = 'none';
  }

  function openPanel(panel, btn, topbar) {
    if (!panel || !btn) return;
    positionPanel(panel, topbar);
    panel.setAttribute('data-bh-nav-open', '');
    btn.setAttribute('aria-expanded', 'true');
    if (topbar) topbar.classList.add(OPEN_CLASS);
    document.documentElement.classList.add(OPEN_CLASS);
  }

  function initTopbar(topbar) {
    if (!topbar || topbar.getAttribute('data-bh-partner-mobile-nav-ready') === '1') return;

    var btn = topbar.querySelector('[data-bh-partner-nav-toggle]');
    var panel = topbar.querySelector('.bh-mia-topnav-rail--dropdown');
    if (!btn || !panel) return;

    btn.addEventListener('click', function (e) {
      if (!isMobileNav()) return;
      e.preventDefault();
      e.stopPropagation();
      if (panel.hasAttribute('data-bh-nav-open')) {
        closePanel(panel, btn, topbar);
      } else {
        openPanel(panel, btn, topbar);
      }
    });

    panel.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function () {
        if (isMobileNav()) closePanel(panel, btn, topbar);
      });
    });

    document.addEventListener('click', function (e) {
      if (!isMobileNav() || !panel.hasAttribute('data-bh-nav-open')) return;
      if (topbar.contains(e.target)) return;
      closePanel(panel, btn, topbar);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !panel.hasAttribute('data-bh-nav-open')) return;
      closePanel(panel, btn, topbar);
      btn.focus();
    });

    global.addEventListener(
      'scroll',
      function () {
        if (!isMobileNav() || !panel.hasAttribute('data-bh-nav-open')) return;
        positionPanel(panel, topbar);
      },
      { passive: true }
    );

    global.addEventListener('resize', function () {
      if (!isMobileNav()) {
        closePanel(panel, btn, topbar);
        return;
      }
      if (panel.hasAttribute('data-bh-nav-open')) positionPanel(panel, topbar);
    });

    try {
      global.matchMedia(MQ).addEventListener('change', function () {
        closePanel(panel, btn, topbar);
      });
    } catch (err) {
      /* ignore */
    }

    topbar.setAttribute('data-bh-partner-mobile-nav-ready', '1');
  }

  function boot() {
    var topbars = document.querySelectorAll('[data-bh-partner-topbar]');
    for (var i = 0; i < topbars.length; i++) {
      initTopbar(topbars[i]);
    }
  }

  global.BeeHivePartnerMobileNav = { init: initTopbar, boot: boot };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : this);
